import React from "react"
import {isMobileOnly, isIOS} from "mobile-device-detect"

import ExternalLink from "./ExternalLink"

function SurpriseLink({shortUrl, receiverName}) {
  const links = []
  
  const whatsapp_text = `Hei, ich habe eine Überraschung von Appentura für dich! ${shortUrl} :)`
  const email_subject = `Überraschung!`
  const email_body = `Hei ${receiverName}, ich habe eine Überraschung von Appentura für dich! ${shortUrl} :)`
  const sms_text = `Hei, ich habe eine Überraschung von Appentura für dich! ${shortUrl}`
  
  if(isMobileOnly) {
    // whatsapp
    const href_whatsapp = `https://wa.me/?text=${encodeURI(whatsapp_text)}`
    links.push(<ExternalLink to={href_whatsapp}>mit Whatsapp verschicken</ExternalLink>)
    // sms
    const href_sms = isIOS ? `sms:&body=${encodeURI(sms_text)}` : `sms:?body=${encodeURI(sms_text)}` // 
    links.push(<ExternalLink to={href_sms}>mit SMS verschicken</ExternalLink>)
  }
  else {
    // whatsapp desktop
    const href_whatsapp = `https://web.whatsapp.com/send?text=${encodeURI(whatsapp_text)}`
    links.push(<ExternalLink to={href_whatsapp}>mit Whatsapp Desktop verschicken</ExternalLink>)
  }
  
  // email
  const href_email = `mailto:?subject=${encodeURI(email_subject)}&body=${encodeURI(email_body)}`
  links.push(<ExternalLink to={href_email}>via E-Mail verschicken</ExternalLink>)
  
  // render
  let content = links.map((link, index) => <div key={index}>{link}</div>)
  return (
    <div>{content}</div>
  )
}

export default SurpriseLink